// @ts-check
import { state } from '../state';
import { calculateLines } from './combs';
import { getTotalMatchItems } from './items';
import { setFoldStake } from './stake';

export const setFoldLines = () => {
	const items = Object.keys(state.items);
	const raceOddItems = Object.keys(state.raceOdds);
	const bankers = state.bankers;
	const matchNum = getTotalMatchItems();
	const allItems = items.concat(raceOddItems);

	const lines = calculateLines(allItems, matchNum, bankers);
	// Filter invalid lines
	state.foldLines = Object.keys(lines).reduce((acc, fl) => {
		if (lines[fl] <= 0 || lines[fl] >= 2048) {
			return acc;
		}
		acc[fl] = lines[fl];
		return acc;
	}, {});
};

/**
 * Reset folds stakes when adding/removing items
 * @param {string} comboStake - previous combo stake amount
 */
export const resetFolds = (comboStake) => {
	const matchNum = `${getTotalMatchItems()}`;
	state.folds = {}
	setFoldLines();
	// FEAT: maybe add setting if to update new combo stake
	if (comboStake && true) {
		setFoldStake(matchNum, comboStake);
	}
};
